var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.og)?_c('div',[_c('a',{attrs:{"href":this.verifyedURL,"target":"_blank"}},[_c('b-icon',{attrs:{"icon":"paperclip"}}),_vm._v(" "+_vm._s(_vm.title))],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }